export enum AVAILABILITY_CONSTANTS {
    AVAILABLE = 'AVAILABLE',
    DELIVERED_ON_DATE = 'DELIVERED_ON_DATE',
    NOT_AVAILABLE = 'NOT_AVAILABLE',
    NOT_AVAILABLE_IN_REGION = 'NOT_AVAILABLE_IN_REGION',
    SOLD_OUT = 'SOLD_OUT',
    WILL_BE_ORDERED = 'WILL_BE_ORDERED',
}
